import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, MatOptionModule } from "@angular/material/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DateAdapter } from "@angular/material/core";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { DateFormatService } from "../services/dateFormat.service";
import { CustomDateAdapter } from "../services/custom-date-adapter";
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from "@angular/material/tooltip";
import { CustomPaginatorIntl } from "../services/custom-paginator-intl.service";
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export function dateFormatFactory(dateFormatService: DateFormatService) {
  let currentFormat = dateFormatService.userDateFormat; // Default format
  return {
    parse: {
      dateInput: currentFormat,
    },
    display: {
      dateInput: currentFormat,
      monthYearLabel: 'MMM yyyy',
      dateA11yLabel: 'PPP',
      monthYearA11yLabel: 'MMM yyyy',
    },
  };
}

@NgModule({
  declarations: [],
  exports: [
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDialogModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSidenavModule,
    MatListModule,
    MatRadioModule,
    MatDatepickerModule,
    NgxMatSelectSearchModule,
    MatExpansionModule,
    MatTabsModule,
    MatTooltipModule,
    MatMenuModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatToolbarModule,
    MatProgressBarModule
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [DateFormatService],
    },
    {
      provide: MAT_DATE_FORMATS,
      useFactory: dateFormatFactory,
      deps: [DateFormatService],
    },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }
  ],
})
export class MaterialModule { }
